export default "__VITE_ASSET__b3d7dc39__"